import { GetLocalState } from "Connectivity/LocalStorage";
import { LoginDataProps } from "Types/LoginDataProps";
import { LoginResultProps } from "Types/LoginResultProps";

export function MakeLoginData(data:LoginResultProps): LoginDataProps {
    
  let _data: LoginDataProps = {

    username          : data.login.user.username,
    status            : data.login.user.status,
    profilePhoto      : data.login.user.profile_photo
                          ? data.login.user.profile_photo
                          : GetLocalState("assets").images.DefaultProfilePhoto,
    city              : data.login.location.city,
    country           : data.login.location.country,
    lastLoginDate     : data.login.user.last_login_date,
    tokenHash         : data.login.token.hash,
  
    firstLogin                  : data.login.user.first_login,
    forceApprovePrivacyPolicy   : data.login.user.force_approve_privacy_policy,
    isEmailVerified             : data.login.user.is_email_verified,
    isKycVerified               : data.login.user.is_kyc_verified,
    isSmsVerified               : data.login.user.is_sms_verified,
    kycEnabled                  : data.login.user.kyc_enabled,
  
    balance           : {
      activeBalance             : data.login.user.balance.active_balance,
      casinoBonusBalance        : data.login.user.balance.casino_bonus_balance,
      currencyCode              : data.login.user.balance.currency_code,
      freeBalance               : data.login.user.balance.free_balance,
      reservedWithdrawBalance   : data.login.user.balance.reserved_withdraw_balance,
      sportBonusBalance         : data.login.user.balance.sport_bonus_balance,
      totalBalance              : data.login.user.balance.total_balance,
      totalBonusBalance         : data.login.user.balance.total_bonus_balance
    }

  }

  return _data;

}